export default class QuestionSeries {
    id: string = "";
    title: string = "";
    description: string = "";
    order: number = 0;
}
